module.exports = __webpack_public_path__ + "img/exclamationPoint.2794803a.svg";